export const enableDevTools =
  process.env.NEXT_PUBLIC_ENABLE_REDUX_DEV_TOOLS === "true";

export const gtmConfig = {
  containerId: process.env.NEXT_PUBLIC_GTM_CONTAINER_ID,
};

export const mapboxConfig = {
  apiKey: process.env.NEXT_PUBLIC_MAPBOX_API_KEY,
};

// AI related config
export const COHERE_CLASSIFICATION_MIN_CONFIDENCE = 0.95

export const hyperDXConfig = {
  apiKey: process.env.NEXT_PUBLIC_HYPERDX_API_KEY,
  serviceName: process.env.NEXT_PUBLIC_OTEL_SERVICE_NAME
};
